var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.76 17.9915V15.8146L10.3614 21.8229L1.88376 16.9248V7.12898L12.3283 1.09426L10.4545 0L0 6.04041V18.0134L10.3614 24L20.76 17.9915Z",
    fill: "#14E2AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7677 15.8362L10.3612 19.6461L20.7598 13.6379V11.4612L10.3612 17.4692L5.65146 14.7481V9.30567L16.0754 3.28298L14.2019 2.18872L3.7677 8.21732V15.8362Z",
    fill: "#14E2AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8231 5.47158L17.9496 4.37732L7.53528 10.3943V13.6598L10.3615 15.2923L20.7601 9.28409V7.10695L10.3615 13.1154L9.41904 12.571V11.4829L19.8231 5.47158Z",
    fill: "#14E2AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aba96b986384e8b16a5e7c959275bc86.svg";
export { ForwardRef as ReactComponent };